import { AppSelect } from '../../../../components/Select'
import { SelectData, SelectOptionString } from '../../../common/filter/models'
import { REPORT_OUTCOME_OPTIONS } from '../core/consts'

export const selectType = 'reportOutcome'

/**
 * Укрупнённый фильтр исхода тикета для отчётов по пополнениям и выплатам (CPAYMENT-1843).
 *
 * Список значений фиксированный, за ним не ходят на бэкенд. Пустой выбор и оба значения разом
 * дают одну и ту же выборку — все финальные тикеты периода.
 *
 * Плейсхолдер называет сам фильтр, а не пустоту выбора: подписи у поля в этой панели нет, а
 * соседние селекты показывают то же «Все» — в ряду одинаковых заглушек по полю не понять, что
 * оно про статус. Не приводить его к соседям.
 */
const ReportOutcomeFilter = ({
  changeSelect,
  value,
}: {
  changeSelect: (selectData: SelectData) => void
  value: string[]
}) => {
  const handleChange = (selectedData: unknown) => {
    const values = ((selectedData as readonly SelectOptionString[] | null) ?? []).map(
      (item) => item.value
    )

    changeSelect({ value: values, type: selectType })
  }

  return (
    <AppSelect
      isMulti
      value={REPORT_OUTCOME_OPTIONS.filter((option) => (value ?? []).includes(option.value))}
      onChange={handleChange}
      options={REPORT_OUTCOME_OPTIONS}
      placeholder={'Без сортировки по статусу'}
      isClearable
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
    />
  )
}

export default ReportOutcomeFilter
